import { connect } from "react-redux";
import LayoutUser2 from "../hocs/LayoutUser2";

const AboutUS = () => {
    return (
        <LayoutUser2>
            <main className="w-full min-h-screen px-2 pt-8 max-w-4xl mx-auto">
                <div className="card shadow-md p-4 rounded-3">
                    <section className="mb-8 text-justify">
                        <h2 className=" font-bold mb-4 text-center text-ecoprimary1">¿Quiénes somos?</h2>
                        <p className="text-gray-700 leading-relaxed">
                            Somos un equipo apasionado por el emprendimiento y la tecnología. Creamos <strong className="text-lg">Mio Precio</strong> con un solo objetivo en mente: conectar a los emprendedores con sus futuros clientes de forma fácil, segura y efectiva. Sabemos lo difícil que puede ser mostrar un producto, generar confianza y concretar una venta, por eso diseñamos una plataforma donde cada negocio tiene la oportunidad de brillar. Nos mueve la unión, el trabajo en equipo y las ganas de crecer junto a nuestros usuarios.
                        </p>
                    </section>

                    <section className="mb-8 text-justify">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Visión</h2>
                        <p className="text-gray-700 leading-relaxed">
                            Ser la plataforma de comercio electrónico más confiable y reconocida de Bolivia, impulsando el crecimiento de miles de emprendedores al conectar sus productos con el cliente final de manera simple, rápida y segura.
                        </p>
                    </section>

                    <section className="mb-8 text-justify">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Misión</h2>
                        <p className="text-gray-700 leading-relaxed">
                            Facilitar el camino de los emprendedores hacia el éxito, brindándoles herramientas digitales, visibilidad en redes sociales, confianza para sus clientes y un espacio donde mostrar lo mejor de sus productos.
                        </p>
                    </section>

                    <section className="text-justify">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Propósito</h2>
                        <p className="text-gray-700 leading-relaxed">
                            Apoyar y potenciar a los pequeños y medianos negocios, democratizando el acceso a la venta online y generando oportunidades reales de crecimiento para todos.
                        </p>
                    </section>
                </div>
            </main>
        </LayoutUser2>
    );
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(AboutUS);
